export function formatParasutReadAt(value) {
  if (value === null || value === undefined || value === '') return '-'

  // Older backend versions serialize Instant as fractional epoch seconds.
  const numeric = typeof value === 'number' || /^\d+(\.\d+)?$/.test(String(value))
  const timestamp = numeric ? Number(value) * (Math.abs(Number(value)) < 1e11 ? 1000 : 1) : value
  const date = new Date(timestamp)
  if (!Number.isFinite(date.getTime())) return '-'

  return new Intl.DateTimeFormat('tr-TR', {
    timeZone: 'Europe/Istanbul', dateStyle: 'short', timeStyle: 'medium',
  }).format(date)
}

export function formatParasutMoney(value, currency) {
  if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) return '-'
  if (!currency) return `${new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value))} (para birimi belirtilmemiş)`
  const code = currency === 'TRL' ? 'TRY' : currency
  try {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency', currency: code, minimumFractionDigits: 2, maximumFractionDigits: 2,
    }).format(Number(value))
  } catch { return `${Number(value).toFixed(2)} ${code}` }
}

export function formatParasutDay(value) {
  if (!value) return '-'
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T)/)

  return match ? `${match[3]}.${match[2]}.${match[1]}` : '-'
}

export function transactionTypeLabel(type, side) {
  // Contact transaction direction is relative to the selected bank account.
  if (['contact_debit', 'contact_credit'].includes(type)) {
    if (side === 'CREDIT') return 'Tedarikçiye Ödeme'
    if (side === 'DEBIT') return 'Müşteriden Tahsilat'

    return 'Cari hesap işlemi'
  }

  return {
    account_debit: 'Bilinmeyen Para Girişi',
    account_credit: 'Bilinmeyen Para Çıkışı',
    bank_fee_payment: 'Banka masrafı',
    tax_payment: 'Vergi ödemesi',
    salary_payment: 'Maaş ödemesi',
    account_transfer: 'Hesaplar arası transfer',
  }[type] || (type ? 'Diğer işlem' : 'Tür belirtilmemiş')
}

export function paymentStatusLabel(status) {
  return {
    paid: 'Ödendi', overdue: 'Vadesi geçti', unpaid: 'Ödenmedi', partially_paid: 'Kısmen ödendi',
  }[status] || 'Belirtilmemiş'
}

export function documentTypeLabel(type) {
  return {
    purchase_bill: 'Gider',
    refund: 'İade',
    cancelled: 'İptal',
    invoice: 'Satış faturası',
    export: 'İhracat',
    estimate: 'Teklif',
    recurring_purchase_bill: 'Tekrarlayan gider',
    recurring_invoice: 'Tekrarlayan fatura',
    salaries: 'Maaş / Prim',
    taxes: 'Vergi / SGK',
  }[type] || type || 'Tür belirtilmemiş'
}
